import { VariableSelectorConfig, VariablesConfig } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

import { OperatorEnum } from './types'

const operatorValues: OperatorEnum[] = [
  'eq',
  'neq',
  'one_of',
  'not_one_of',
  'gt',
  'gte',
  'lt',
  'lte',
]

const hasMultiSelectSupport = (config?: VariableSelectorConfig): boolean =>
  !!(config && 'multiSelect' in config && config.multiSelect)

export const getOperatorValuesForVariable = (
  variablesConfig: VariablesConfig,
  variableName?: string
): OperatorEnum[] => {
  if (!variableName) {
    return operatorValues.filter((value) => value !== 'one_of' && value !== 'not_one_of')
  }

  const config = variablesConfig[variableName]
  const hasMultiSelect = hasMultiSelectSupport(config)

  switch (config?.type) {
    case 'entity':
    case 'text':
      // Include 'one_of' and 'not_one_of' operators only if multi-select component is available
      if (hasMultiSelect) {
        return operatorValues.filter(
          (value) => value === 'eq' || value === 'neq' || value === 'one_of' || value === 'not_one_of'
        )
      }
      return operatorValues.filter((value) => value === 'eq' || value === 'neq')
    default:
      // For non-entity types, exclude 'one_of' and 'not_one_of' operators
      return operatorValues.filter((value) => value !== 'one_of' && value !== 'not_one_of')
  }
}

